import * as O from "fp-ts/Option";
import { identity } from "fp-ts/function";
import * as Setoid from "../setoid";
export * from "./lift";
export * from "./optics";
export * from "./helpers";
export var Tags;
(function (Tags) {
    Tags["Just"] = "Just";
    Tags["Nothing"] = "Nothing";
})(Tags || (Tags = {}));
export const is = {
    [Tags.Just]: O.isSome,
    [Tags.Nothing]: O.isNone,
};
export const unsafeJust = O.some;
export const isMaybe = (m) => typeof m === "object" &&
    m !== null &&
    Object.prototype.hasOwnProperty.call(m, "_tag") &&
    (m._tag === "Some" ||
        m._tag === "None");
/**
 * @deprecated since 2.0
 * Use `getOrElse` from "fp-ts/Option" instead.
 */
export const fromMaybe = (m, a) => O.fold(() => a, identity)(m);
/**
 * @deprecated since 2.0
 * Use `map` from "fp-ts/Option" instead.
 */
export const map = (g, m) => O.map(g)(m);
/**
 * @deprecated since 2.0
 * Use `fold` from "fp-ts/Option" instead.
 */
export const maybe = (b, f, m) => O.fold(() => b, f)(m);
const E = O.getEq(Setoid);
/**
 * @deprecated since 2.0
 * Use `getEq` from "fp-ts/Option" instead.
 */
export const equals = (m1, m2) => E.equals(m1, m2);
const M = O.getFirstMonoid();
/**
 * @deprecated since 2.0
 * Use `getFirstMonoid` from "fp-ts/Option" instead.
 * Or more general `getMonoid` for other behaviour.
 */
export const concat = (m1, m2) => M.concat(m1, m2);
/**
 * @deprecated since 2.0
 * If empty was used to create Nothing, then use `Option.none`.
 *
 * For monoid behaviour use `getFirstMonoid` from "fp-ts/Option" instead.
 * Or more general `getMonoid` for other behaviour.
 */
export const empty = () => M.empty;
/**
 * @deprecated since 2.0
 * Use `filter` from "fp-ts/Option" instead.
 */
export const filter = (p, m) => O.filter(p)(m);
/**
 * @deprecated since 2.0
 * Use `fromNullable` from "fp-ts/Option" instead.
 * *WARNING* this isn't proper `of` implementation,
 * therefore migrating is *strongly* recomended.
 */
export const of = (a) => O.fromNullable(a);
/**
 * @deprecated since 2.0
 * Use `ap` from "fp-ts/Option" instead.
 * *WARNING* Previous implementatien used our bogus `of`,
 * so current behavior may be different.
 */
export const ap = (m1, m2) => O.ap(m2)(m1);
/**
 * @deprecated since 2.0
 * Use `alt` from "fp-ts/Option" instead.
 */
export const alt = concat;
/**
 * @deprecated since 2.0
 * Use `chain` from "fp-ts/Option" instead.
 */
export const chain = (g, m) => O.chain(g)(m);
/**
 * @deprecated since 2.0
 * Use `flatten` from "fp-ts/Option" instead.
 */
export const join = (m) => O.flatten(m);
/**
 * @deprecated since 2.0
 * Use `reduce` from "fp-ts/Option" instead.
 */
export const reduce = (g, a, m) => O.reduce(a, g)(m);
/**
 * @deprecated since 2.0
 * Use `foldMap` from "fp-ts/Option" instead.
 */
export const foldMapConst = (g, a, m) => reduce((_, b) => g(b), a, m);

